import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Sparkles } from 'lucide-react';

const FinalCTA = ({ onStartClick }) => {
  const { t } = useTranslation();
  return (
    <div className="py-24 px-4 bg-gradient-to-br from-purple-100/70 via-pink-100/70 to-amber-100/70" data-testid="final-cta">
      <div className="max-w-3xl mx-auto text-center fade-in">
        <Sparkles className="w-10 h-10 text-amber-400 mx-auto mb-6 float-animation" />
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-5 leading-tight">{t('cta.headline')}</h2>
        <p className="text-base text-gray-600 mb-10">{t('cta.subtitle')}</p>
        <Button size="lg" onClick={onStartClick} className="btn-primary text-white px-12 py-6 text-base font-semibold rounded-full border-0" data-testid="final-cta-start-btn">{t('cta.button')}</Button>
      </div>
    </div>
  );
};
export default FinalCTA;
